import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export type SrcsetItem = { url: string; w: number };
export const STANDARD_WIDTHS = [400, 800, 1200] as const;

export const buildSrcset = (baseNoWidth: string): SrcsetItem[] =>
    STANDARD_WIDTHS.map(w => ({ url: `${baseNoWidth}-${w}.webp`, w }));

export interface LcpPreloadOptions {
    id: string;
    href: string;
    srcset?: SrcsetItem[];
    sizes?: string;
}

@Injectable({ providedIn: 'root' })
export class LcpImagePreloadService {
    constructor(@Inject(DOCUMENT) private doc: Document) {}

    preload(opts: LcpPreloadOptions): HTMLLinkElement {
        const defaultSizes = "(min-width: 1340px) 611px, (min-width: 780px) calc(43.52vw + 39px), (min-width: 440px) 350px, 83.33vw";
        const existing = this.doc.head.querySelector<HTMLLinkElement>(
            `link[rel="preload"][data-lcp-id="${opts.id}"]`
        );
        if (existing) {
            return existing;
        }

        const link = this.doc.createElement('link');
        link.rel = 'preload';
        link.as  = 'image';
        link.href = opts.href;
        link.setAttribute('data-lcp-id', opts.id);

        if (opts.srcset?.length) {
            const srcsetStr = opts.srcset.sort((a,b)=>a.w-b.w)
                .map(i => `${i.url} ${i.w}w`).join(', ');
            link.setAttribute('imagesrcset', srcsetStr);
        }
        link.setAttribute('imagesizes', opts.sizes || defaultSizes);
        link.setAttribute('fetchpriority', 'high');

        this.doc.head.appendChild(link);
        return link;
    }

    remove(id: string) {
        this.doc.head.querySelector(`link[rel="preload"][data-lcp-id="${id}"]`)?.remove();
    }

}
